import React from 'react';
import { connect } from 'react-redux';
import {
  columnEmail,
  columnNameLink,
  columnMultiSelect,
  columnTools,
  columnApproved,
  columnRole,
  columnRoleLink,
  columnRoleLinkNoFilter,
  columnSearchable,
  columnCreatedOn,
  columnUpdatedOn,
  columnUserRole,
  columnUserGroups,
  columnArchived,
  hasColumn,
} from '@/constants/fields';
import { sortingFilters } from '@/constants/states';
import TableSortedColumn from '@/components/table/TableSortedColumn';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import NameDescriptionColumns from '@/components/table/NameDescriptionColumns';
import { toggleUsersSelected, toggleUsersColumnOrderBy } from '../actions';

const UsersTableColumns = ({
  category,
  items,
  onCheckBoxClick,
  onOrderByColumn,
  orderBy,
  singleSorting,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnSearchable,
    columnApproved,
    columnEmail,
    columnRole,
    columnUserGroups,
    columnTools,
    columnCreatedOn,
    columnUpdatedOn,
  ],
}) => (
  <NameDescriptionColumns
    category={category}
    columns={columns}
    entity="user"
    items={items}
    onCheckBoxClick={({ selected }) => onCheckBoxClick(category, selected)}
    onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
    orderBy={orderBy}
    singleSorting={singleSorting}
  >
    {hasColumn(columns, columnEmail) && (
    <TableSortedColumn
      name={columnEmail}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, [columnRole, columnRoleLink, columnRoleLinkNoFilter]) && (
    <TableSortedColumn
      name={columnRole}
      orderByColumnFindName={columnUserRole}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnUserGroups) && (<UnsortedColumn columnId={columnUserGroups} />)}
    {hasColumn(columns, columnCreatedOn) && (
    <TableSortedColumn
      name={columnCreatedOn}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnUpdatedOn) && (
    <TableSortedColumn
      name={columnUpdatedOn}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnArchived) && (
    <TableSortedColumn
      name={columnArchived}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnApproved) && (
    <TableSortedColumn
      name={columnApproved}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
    {hasColumn(columns, columnSearchable) && (
    <TableSortedColumn
      name={columnSearchable}
      onOrderByColumn={({ orderByColumn }) => onOrderByColumn(category, orderByColumn)}
      orderBy={orderBy}
      singleSorting={singleSorting}
      sortable={category}
    />
    )}
  </NameDescriptionColumns>
);

const mapStateToProps = ({
  auth: { users },
}, { category }) => {
  const { orderBy, singleSorting } = users[category] || sortingFilters();
  return ({ orderBy, singleSorting });
};

const mapDispatchToProps = {
  onCheckBoxClick: toggleUsersSelected,
  onOrderByColumn: toggleUsersColumnOrderBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersTableColumns);
